import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { Dropdown } from "primereact/dropdown"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"
import GLOBALS_STATUS from "../../../config/globalsStatus"

const CONVERT_TO_SERVICE_VALUE = "Convert to service"
const STAFF_ASSIGNMENT_VALUE = "Staff assignment"
const REACTIVATE_PARTICIPANT_VALUE = "Participant reactivation"

export default function ManageServicesType({ field, block, index }) {
  const [staffStatusRelation, setStaffStatusRelation] = useState()
  const [optionList, setOptionList] = useState([])

  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GET_STATUS_WITH_STAFF = gql`
    query getStatusWithStaff(
      $staff_id: ID!
      $organization_id: ID!
      $participant_membership_id: ID!
    ) {
      staffRelationByMembershipId(
        staff_id: $staff_id
        organization_id: $organization_id
        participant_membership_id: $participant_membership_id
      ) {
        status_with_staff
      }
    }
  `
  const { loading } = useQuery(GET_STATUS_WITH_STAFF, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      participant_membership_id: userCtx.participant_membership_id,
    },
    onCompleted: ({ staffRelationByMembershipId }) => {
      setStaffStatusRelation(staffRelationByMembershipId.status_with_staff)
    },
    skip: !userCtx,
  })
  useEffect(() => {
    const relation = parseInt(staffStatusRelation)
    if (relation === 1 || relation === -4 || relation === -3) {
      const isKioskMember =
        userCtx.participant_membership_status === GLOBALS_STATUS.KIOSK_MEMBER

      const filteredOptions =
        field.field_options?.filter((option) => {
          //Always exclude the Reactivation option from this listing
          if (option.value === REACTIVATE_PARTICIPANT_VALUE) {
            return false
          }

          if (isKioskMember) {
            //For Kiosk members, do not show Staff assignment
            return option.value !== STAFF_ASSIGNMENT_VALUE
          }

          //If this is not a Kiosk member, show all options except Convert to service
          return option.value !== CONVERT_TO_SERVICE_VALUE
        }) ?? []

      setOptionList(filteredOptions)
    } else if (relation === -3 || relation === -2 || relation === -1) {
      //reactivate participant
    } else {
      setOptionList([])
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik])

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={optionList}
                optionLabel="label"
                optionValue="value"
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
